<template>
  <div class="gray-chip">
    <span>{{ number }}</span>
  </div>
</template>

<script>
export default {
  name: 'NumberChip',
  props: {
    number: {
      type: [Number, String],
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
.gray-chip {
  padding: 2px 12px;
  border-radius: 16px;
  font-size: 14px;
  background: $cinza-l80;
  color: $cinza-d20;
  font-weight: bold;
  white-space: nowrap;
  width: fit-content;
  user-select: none;
}
</style>
